import { render, staticRenderFns } from "./m3u8Video.vue?vue&type=template&id=0375225c&scoped=true"
import script from "./m3u8Video.vue?vue&type=script&lang=js"
export * from "./m3u8Video.vue?vue&type=script&lang=js"
import style0 from "./m3u8Video.vue?vue&type=style&index=0&id=0375225c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0375225c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0375225c')) {
      api.createRecord('0375225c', component.options)
    } else {
      api.reload('0375225c', component.options)
    }
    module.hot.accept("./m3u8Video.vue?vue&type=template&id=0375225c&scoped=true", function () {
      api.rerender('0375225c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/m3u8Video.vue"
export default component.exports